// src/routes/product.routes.js
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '../guards/authGuard';

// Lazy load product pages
const ProductManagement = lazy(() => import('../pages/dashboard/productManagement'));
const ProductForm = lazy(() => import('../pages/dashboard/productForm'));
const ProductStockUpdate = lazy(() => import('../pages/dashboard/productStockUpdate'));
const ProductImport = lazy(() => import('../pages/dashboard/productImport'));

const productRoutes = {
  path: 'products',
  element: (
    <AuthGuard>
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <ProductManagement />
    },
    {
      path: 'create',
      element: <ProductForm mode="create" />
    },
    {
      path: 'edit/:productId',
      element: <ProductForm mode="edit" />
    },
    {
      path: ':productId/stock',
      element: <ProductStockUpdate />
    },
    {
      path: 'import',
      element: <ProductImport />
    }
  ]
};

export default productRoutes;